export default __webpack_public_path__ + "static/media/debate_5.6b4ee194.JPG";